import type { Deck } from '@/entities/deck'
import type { DeepReadonly } from 'vue'

export function useDetectWebGL({ deck, onNoWebGL }: { deck: DeepReadonly<Ref<Deck>>; onNoWebGL: () => void }): void {
  onMounted(() => {
    if (!deck.value.slides.find(s => s.type === 'S' || s.type === 'M')) return

    const canvas = document.createElement('canvas')
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')

    if (!(gl instanceof WebGLRenderingContext)) onNoWebGL()
  })
}
